module.exports = __webpack_public_path__ + "img/show-img2.69a16b69.png";